// import { Type } from "class-transformer";
// import { IsArray, IsEnum, IsNotEmpty, IsString, ValidateNested } from "class-validator";
import z from "zod";

import { UserType } from "@/types/user.types";

const passengerBaseChangeSchema = z.object({
    field: z.enum([
        "origin",
        "destination",
        "status",
        "pickUp",
        "dropOff",
        "note",
        "cancelled",
        "isSelfTransport",
        "flightNumber",
        "flightTime",
    ]),
    from: z.string().nullable(),
    to: z.string().nullable(),
});
export const passengerUserChangeSchema = z
    .object({
        id: z.string(),
        name: z.string(),
        userType: z.nativeEnum(UserType),
        email: z.string(),
        isDeleted: z.boolean().optional().nullable(),
    })
    .nullable();
export const passengerDriverChangeSchema = passengerBaseChangeSchema.extend({
    field: z.literal("driverId"),
    from: z.string().nullable(),
    to: z.string().nullable(),
    fromDriver: passengerUserChangeSchema,
    toDriver: passengerUserChangeSchema,
});
export const companionSchema = z.object({
    name: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
});
export const companionListSchema = z.array(companionSchema).nullable();
export const passengerCompanionChangeSchema = passengerBaseChangeSchema.extend({
    field: z.literal("companions"),
    from: companionListSchema.nullable(),
    to: companionListSchema.nullable(),
});

export enum PassengerHistoryTypes {
    // Create
    CREATE_CUSTOM_PASSENGER = 1,

    // Update
    WELCOME_TEAM_UPDATE = 100,
    PLAN_PAGE_UPDATE,
    TRACKING_PAGE_UPDATE,
    UHM_UPDATE,
    MOBILE_APP_TASK_PROGRESS_UPDATE,
    PASSENGER_REQUEST_UPDATE,
    OPERATION_SERVICE_UPDATE,

    // Driver
    DRIVER_PLAN_PAGE_ASSIGN = 200,
    DRIVER_PLAN_PAGE_UNASSIGN,
    OPERATION_SERVICE_UNASSIGN,
    TRACKING_PAGE_ASSIGN,
    TRACKING_PAGE_UNASSIGN,

    // Delete
    DELETE_CUSTOM_PASSENGER = 300,
}

export enum PassengerHistoryActorType {
    USER = 1,
    SYSTEM,
}

const PassengerChangeItemSchema = z.union([
    passengerBaseChangeSchema,
    passengerDriverChangeSchema,
    passengerCompanionChangeSchema,
]);

export const PassengerHistorySchema = z.object({
    id: z.string(),
    passengerDbId: z.string(),
    type: z.nativeEnum(PassengerHistoryTypes),
    browser: z.string().nullable().optional(),
    platform: z.string().nullable().optional(),
    os: z.string().nullable().optional(),
    createdAt: z.string().datetime({ offset: true }),
    changes: z.array(PassengerChangeItemSchema),
    actor: passengerUserChangeSchema,
    actorType: z.nativeEnum(PassengerHistoryActorType),
});
export const PassengerHistoryListSchema = z.array(PassengerHistorySchema);

export type IPassengerHistory = z.infer<typeof PassengerHistorySchema>;
export type IPassengerHistoryChangeItem = z.infer<typeof PassengerChangeItemSchema>;
export type IPassengerHistoryActor = z.infer<typeof passengerUserChangeSchema>;
export type IPassengerHistoryList = z.infer<typeof PassengerHistoryListSchema>;
export type IPassengerHistoryCompanion = z.infer<typeof companionSchema>;
export type IPassengerHistoryCompanionList = z.infer<typeof companionListSchema>;
